<template>
	<div id="overview">
		<div class="container-fluid">
			<div>
				<div class="header">
					<div class="filters-wrapper">
						<div class="filter-dropdown">
							<span>Select Store</span>
							<b-form-select
								style="width: 200px;  height: 34px; padding: 5px;"
								v-model="selectedStore"
								:options="storeOptions"
							></b-form-select>
						</div>
						<div class="filter-dropdown">
							<span>Job Position</span>
							<b-form-select
								style="width: 200px;  height: 34px; padding: 5px;"
								v-model="selectedJobPosition"
								:options="jobPositionOptions"
							></b-form-select>
						</div>
					</div>
					<div class="middle-wrapper">
						<div class="dates">
							<span> {{ currentWeek.weekTitle }} </span>
							<div
								class="button-info"
								@mouseover="isWeekInfoVisible = true"
								@mouseleave="isWeekInfoVisible = false"
							>
								i
							</div>
							<transition name="fade" appear mode="out-in">
								<weekInfo v-show="isWeekInfoVisible" />
							</transition>
						</div>
					</div>
					<div class="weeks-wrapper">
						<div class="button-left" @click="handlePreviousWeekClick">
							<b-icon-chevron-compact-left />
						</div>
						<div class="indicator">Current Week ({{ currentWeek.weekNumber }})</div>
						<div class="button-right" @click="handleNextWeekClick">
							<b-icon-chevron-compact-right />
						</div>
					</div>
				</div>
			</div>
			<div class="row content">
				<div class="calendar-days">
					<span class="staff-title">STAFF</span>
					<day
						v-for="(day, index) in currentWeek.days"
						:key="index"
						:title="day.title"
						:revenueFrom="day.revenueFrom"
						:revenueTo="day.revenueTo"
						:index="index"
						:isLaborVisible="false"
						:isDayInfoButtonVisible="false"
					>
					</day>
				</div>
				<div class="calendar-content">
					<!-- <template v-for="(jobPosition, index) in jobPositions">
						<div class="shift-row" :key="index" v-if="jobPosition.shiftList.length">
							<div class="shift-grid">
								<div
									class="shift-day-group"
									v-for="(dayShiftList, index) in jobPosition.shiftList"
									:key="index"
								>
									<shift
										v-for="(shift, index) in dayShiftList.values"
										:key="index"
										:id="shift.id"
										:time="shift.shiftTimeString"
										:employeeFullName="shift.employeeFullName"
										:weather="shift.weather"
										:dateMoment="currentDateTime"
										:position="jobPosition.title"
										:statusColors="convertedShiftColors"
										:status="shift.status"
										:isShiftSelected="selectedShiftId === shift.id"
										@shiftClick="handleShiftClick"
									/>
								</div>
							</div>
						</div>
					</template> -->
					<template v-for="(employee, index) in employeeShifts">
						<div class="shift-row" :key="index">
							<div class="employeeDetails">
								<empoyee
									:id="employee.id"
									:fullName="employee.fullName"
									:workedHours="employee.workedHours"
									:tagList="employee.tagList"
									:initials="employee.initials"
								/>
							</div>
							<div class="shift-grid" v-if="employee.shiftList.length">
								<div
									class="shift-group"
									v-for="(employeeShiftList, index) in employee.shiftList"
									:key="index"
								>
									<!-- <span v-for="index in 2" :key="index">test - {{ index }}</span> -->
									<shift
										v-for="(shift, index) in employeeShiftList.values"
										:key="index"
										streach
										:id="shift.id"
										:status="shift.status"
										:statusColors="convertedShiftColors"
										view="Overview"
									>
										<template
											v-slot:position
											v-if="shift.status !== 'unassigned' && shift.status !== 'dayOff'"
										>
											<span class="time normal">Assistant Manager</span>
										</template>
										<template v-slot:time v-if="shift.status !== 'unassigned'">
											<span class="time"> {{ shift.shiftTimeString }}</span>
										</template>
										<template v-slot:unassigned v-if="shift.status === 'unassigned'">
											<span class="single-title">No Shift Assigned </span>
										</template>
									</shift>
								</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import day from '@/components/day';
import employeeSidebar from '@/components/Overview/employeeSidebar';
import shift from '@/components/shift';
import settings from '@/components/settings';
import weekInfo from '@/components/weekInfo';
import empoyee from '@/components/Overview/employee';

import {
	dayList,
	getDaysArray,
	getWeekDays,
	shiftList,
	getEmployeeShiftList,
	overviewEmployeeList,
	groupByArray,
	isJson,
	employeeList,
	storeList,
	jobPositionList,
} from '../api';
import { getForecast } from '../weatherLayer';
import { statusInitialColors } from '../config';

export default {
	name: 'Overview',
	metaInfo: {
		title: 'Overview',
	},
	components: { day, weekInfo, empoyee, shift },

	data() {
		return {
			employeeList: [...employeeList],

			completion: 72,
			isFilterListActive: false,
			isWeekInfoVisible: false,
			isDayInfoVisible: false,
			foreCast: [],

			shiftColors: { ...statusInitialColors },
			employeeShifts: [...overviewEmployeeList],
			shiftTile: {},
			selectedShiftId: 0,
			shiftList: [...shiftList],

			currentWeek: {
				weekNumber: 0,
				weekTitle: '',
				days: [],
			},

			modals: [
				{
					name: '',
					component: '',
				},
			],
			currentModal: '',
			selectedJobPosition: '1',
			selectedStore: '1',
			storeOptions: [...storeList],
			jobPositionOptions: [...jobPositionList],
		};
	},
	created() {
		if (this.localStorageLoad()) {
			this.shiftColors = JSON.parse(this.localStorageLoad());
		} else {
			this.localStorageUpdate(this.shiftColors);
		}
	},
	async mounted() {
		this.foreCast = await getForecast(this.$http, this.$moment, {
			lat: 37.9568,
			lng: 23.742457,
			units: 'metric',
		});

		// get current week number
		this.currentWeek.weekNumber = parseInt(this.$moment().format('W'));

		// get week days from current week
		const weekDayObject = getWeekDays(this.$moment, { current: true });
		this.currentWeek.weekTitle = `${weekDayObject.weekStartDate.date()} - ${weekDayObject.weekEndDate.date()} ${
			weekDayObject.monthString
		} ${weekDayObject.yearString}`;

		// TODO: refactor when data comes
		this.currentWeek.days = dayList.map((day, index) => {
			day.title = weekDayObject.days[index];
			return day;
		});

		this.employeeShifts = getEmployeeShiftList(this.$moment).map(employee => {
			const test = employee.shiftList.filter(shift =>
				this.$moment(shift.key).isBetween(weekDayObject.weekStartDate, weekDayObject.weekEndDate, null, '[]'),
			);
			return {
				...employee,
				shiftList: test,
			};
		});
	},
	computed: {
		canAssignEmployees() {
			return this.shiftTile.shiftStatus === 'unassigned';
		},
		currentDateTime() {
			return this.$moment();
		},
		convertedShiftColors() {
			return isJson(this.shiftColors) ? JSON.parse(this.shiftColors) : this.shiftColors;
		},
	},
	methods: {
		localStorageLoad() {
			return localStorage.getItem('scheduling');
		},
		localStorageUpdate(itemsObject) {
			localStorage.setItem('scheduling', JSON.stringify(itemsObject));
		},
		handleColorsChange(colorsObject) {
			this.shiftColors = colorsObject;
		},
		handleFocus() {
			this.isFilterListActive = true;
		},
		handleFocusOut() {
			this.isFilterListActive = false;
		},
		handleNextWeekClick() {
			this.resolveDates('increase');
		},
		handlePreviousWeekClick() {
			this.resolveDates('decrease');
		},
		resolveDates(method) {
			this.currentWeek.weekNumber =
				method === 'increase' ? this.currentWeek.weekNumber + 1 : this.currentWeek.weekNumber - 1;
			const weekDayObject = getWeekDays(this.$moment, { weekNumber: this.currentWeek.weekNumber });

			// TODO: refactor when data comes
			this.currentWeek.weekTitle = `${weekDayObject.weekStartDate.date()} - ${weekDayObject.weekEndDate.date()}
										  ${weekDayObject.monthString} ${weekDayObject.yearString}`;
			this.currentWeek.days = dayList.map((day, index) => {
				day.title = weekDayObject.days[index];
				return day;
			});
			this.employeeShifts = getEmployeeShiftList(this.$moment).map(employee => {
				const test = employee.shiftList.filter(shift =>
					this.$moment(shift.key).isBetween(
						weekDayObject.weekStartDate,
						weekDayObject.weekEndDate,
						null,
						'[]',
					),
				);
				return {
					...employee,
					shiftList: test,
				};
			});
		},
		handleShiftClick(shiftId, position) {
			const currentShift = this.shiftList.find(x => x.id === shiftId);
			this.selectedShiftId = shiftId;
			this.shiftTile = {
				id: currentShift.id,
				shiftStatus: currentShift.status,
				date: currentShift.date,
				shiftTimeString: currentShift.shiftTimeString,
				position: position,
				event: currentShift.event,
				weather: currentShift.weather,
			};
		},
	},
};
</script>
<style lang="scss">
#overview {
	font-family: 'Open Sans', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #616e84;

	.button-info {
		width: 16px;
		height: 16px;
		font-size: 11px;
		border-radius: 50%;
		color: #fff;
		background-color: #616e84;
		cursor: pointer;
	}
	.day .title-wrapper .title {
		margin-right: 30px;
	}

	.header {
		position: relative;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding: 20px;
		border-bottom: solid 1px #e6e6e6;

		.filters-wrapper {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			z-index: 10;

			.filter-dropdown:not(:first-child) {
				margin-left: 40px;
			}
			.filter-dropdown {
				display: flex;
				flex-direction: row;
				width: 100%;
				align-items: center;
				span {
					font-size: 15px;
					font-weight: 300;
					width: 100px;
					margin-right: 5px;
				}
			}

			.filters {
				position: relative;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				z-index: 2;
				width: 114px;
				// height: 40px;
				padding: 5px;
				margin-right: 25px;
				border-radius: 3.2px;
				box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.21);
				background-color: #ffffff;

				span {
					font-weight: bold;
					cursor: pointer;
				}

				.filter-box {
					position: absolute;
					top: 0;
					left: 0;
					width: 302px;
					height: 307px;

					z-index: -1;
					background-color: #fff;
					box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.21);
					outline: none;
				}
				.filter-box:focus {
					outline: none;
				}
			}
		}
		.middle-wrapper {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;

			.dates {
				position: absolute;
				left: 0;
				right: 0;
				margin-left: auto;
				margin-right: auto;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				z-index: 0;
				span {
					font-size: 22px;
					color: #616e84;
					margin-right: 20px;
				}
			}
			.progress-wrapper {
				width: 170px;
				margin-left: 20px;
				.comletion {
					font-size: 11px;
				}
			}
			.btn-publish {
				margin-left: 20px;
				padding: 4px 10px;
				font-size: 14px;
				border-radius: 3px;
				border-color: transparent;
				background-color: #616e84;
				color: #fff;
			}
		}
		.weeks-wrapper {
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			z-index: 10;

			.button-left,
			.button-right,
			.indicator {
				margin-right: 10px;
			}

			.indicator {
				border-radius: 3px;
				font-size: 14px;
				border: solid 1px #eceded;
				background-color: #ffffff;
				color: #616e84;
				padding: 5px;
			}

			.button-right,
			.button-left {
				width: 32.5px;
				height: 32.5px;
				// padding: 5px;
				font-size: 23px;

				border-radius: 3px;
				border: solid 1px #eceded;
				background-color: #ffffff;
				cursor: pointer;
			}
		}
	}
	.content {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		padding: 0 20px;
		.calendar-days {
			display: grid;
			grid-template-columns: 300px auto auto auto auto auto auto auto;
			align-items: center;
			width: 100%;
			padding-top: 10px;
			border-bottom: solid 1px #ffb03f;

			.staff-title {
				justify-self: self-start;
				font-size: 14px;
				font-weight: bold;
			}
		}
		.calendar-content {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			width: 100%;
			margin-top: 10px;

			.shift-row {
				display: flex;
				width: 100%;
				margin-top: 15px;

				.employeeDetails {
					width: 350px;
				}

				.shift-grid {
					display: grid;
					grid-template-columns: repeat(7, calc((100vw - 350px) / 7));
					// height: min-content;
					height: auto;
					width: calc(100vw - 350px);

					.shift-group {
						display: flex;
						flex-direction: row;
						align-items: center;
						justify-content: center;
					}
				}
			}
		}
	}
}
</style>
